import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Box from 'grommet/components/Box'
import Hero from 'grommet/components/Hero'
import Heading from 'grommet/components/Heading'
import Image from 'grommet/components/Image'
import Paragraph from 'grommet/components/Paragraph'

import Footer from '../components/Footer'
import Header from '../components/Header'
import MenuItems from '../components/menus/MenuItems'
import ActionLinks from '../components/ActionLinks'

import '../styles/Home.css'

class Home extends Component {
  render () {
    const {
      history,
      data
    } = this.props

    const {
      title,
      subtitle,
      menuItems,
      actionLinks
    } = data

    return (
      <div className='Home'>

        <Hero background={this._renderHeroBackground()} backgroundColorIndex='dark'>
          <Header
            transparent />

          <Box align='center' margin={{top: 'large'}}>
            <Heading margin='none' strong>{title}</Heading>
            <Paragraph align='center' size='large'>{subtitle}</Paragraph>
            <ActionLinks links={actionLinks} history={this.props.history} />
          </Box>
        </Hero>

        <div className='content'>
          <MenuItems menuItems={menuItems} history={history} />
        </div>

        <Footer
          isRoot={this.props.isRoot}
          history={this.props.history} />
      </div>
    )
  }

  _renderHeroBackground () {
    return (
      <div>
        <Image src='/images/inline/monster.jpg' className='hero-image' />
        <Image src='/images/inline/Overlay.png' className='overlay' />
      </div>
    )
  }
}

Home.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object,
  isRoot: PropTypes.bool
}

export default Home



// WEBPACK FOOTER //
// ./src/layouts/Home.js